export default {
  opponentRank: {
    title: "Ranking do adversário",
    tabs: {
      byRanking: "Por ranking",
      allRankings: "Todos os rankings",
    },
    empty: {
      title: "Nenhum ranking de adversário disponível",
    },
  },
};